import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().min(2).max(50),
  password: z.string().min(2).max(50),
});

export type TLogin = z.infer<typeof loginSchema>;


export const restPasswordSchema = z.object({
  email: z.string().min(2).max(50),
});
export type TPassword = z.infer<typeof restPasswordSchema>;
